<form
    (ngSubmit)="onSearch(formObj)"
    #formObj="ngForm"
    #formElRef
    class="gtm-search-external-form"
    appClickOutside
    (clickOutside)="closeSuggestions()"
    [ngClass]="{
        'header-search selenium-search-header': type === 'for-header',
        'home-search': type === 'for-browse',
        'error-search': type === 'for-error',
    }"
    autocomplete="off"
>
    <input
        #formInput
        type="text"
        class="external-search-input form-control"
        placeholder="{{ placeholder || 'Start a new search' }}"
        name="q"
        aria-label="Start a new search"
        [attr.title]="formObj.value?.q || null"
        ngModel
        autocomplete="off"
        (ngModelChange)="onInputChange($event)"
        (keydown)="onSuggestionsKeydown($event)"
        (focus)="onFocusOrClick($event.target.value)"
        (click)="onFocusOrClick($event.target.value)"
        (blur)="onInputBlur($event)"
    />
    <app-search-suggestions-dropdown
        [suggestions]="suggestions"
        [isOpen]="isSuggestionsOpen"
        [activeIndex]="activeSuggestionIndex"
        [showPopularHeading]="showPopularHeading"
        (suggestionSelected)="onSelectSuggestion($event)"
    ></app-search-suggestions-dropdown>
    <button
        #submitBtn
        class="btn btn-primary selenium-external-search-button"
        [ngClass]="{ 'button-text': buttonText }"
        aria-label="Search"
        type="submit"
    >
        <span *ngIf="buttonText">{{ buttonText || "" }}</span>
        <app-icon class="icon search-icon" [type]="'Redesign-search'"></app-icon>
    </button>
</form>
